import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
	selector: 'app-raw-filter',
	templateUrl: './raw-filter.component.html',
	styleUrls: ['./raw-filter.component.css'],
})
export class RawFilterComponent {
	@Input() filterModel: any;
	@Input() key: any = 'filter';
	@Output() filterChanged: EventEmitter<any> = new EventEmitter<any>();
	show: boolean;

	ngOnInit() {
		this.show = true;

		this.filterModel = this.filterModel.map((item) => ({
			...item,
			isSelected: item.isSelected ?? true,
		}));
		this.filterModel.sort((a, b) => {
			if (a.name === 'N/A') return 1; // Move 'N/A' to the end
			if (b.name === 'N/A') return -1; // Move 'N/A' to the end
			return a.name.localeCompare(b.name);
		});
		//this.sortFilterModel();
	}

	onFilterChange(data): void {
		this.filterChanged.emit({
			[this.key]: this.filterModel,
		});
	}
	sortFilterModel(): void {
		Object.keys(this.filterModel).forEach((key) => {
			this.filterModel.sort((a, b) => a.name.localeCompare(b.name));
		});
	}
	count(b) {
		return b.filter((obj) => obj.isSelected).length;
	}
}
